export function initHeader() {
  var header = document.getElementById('mj-header');
  var isAdminBar = document.body.classList.contains('admin-bar');
  var mobileAdminBarMq = window.matchMedia('(max-width: 600px)');
  if (!header) return;

  var ticking = false;
  var update = function () {
    if (document.body.classList.contains('drawer-open')) return;
    header.classList.toggle('is-scrolled', window.scrollY > 40);
    if (isAdminBar && mobileAdminBarMq.matches) {
      document.body.classList.toggle('adminbar-scrolled', window.scrollY > 46);
    }
    var zones = document.querySelectorAll('[data-header-logo]');
    var headerH = header.offsetHeight;
    var topmost = null;
    for (var i = 0; i < zones.length; i++) {
      var r = zones[i].getBoundingClientRect();
      if (r.top < headerH && r.bottom > 0) {
        if (!topmost || r.top > topmost.top) { topmost = { el: zones[i], rect: r }; }
      }
    }
    var useDark = false;
    if (topmost && topmost.el.getAttribute('data-header-logo') === 'dark') {
      var darkBottom = topmost.rect.bottom;
      var switchThreshold = headerH + -10;
      useDark = darkBottom > switchThreshold;
    }
    header.classList.toggle('is-over-dark', useDark);
    ticking = false;
  };
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  });
  update();
}
